import { Vehicle } from '@vromo/models';
import React, { ReactElement } from 'react';
import DriverContact from './components/DriverContact';
import StepsDropdown from './components/StepsDropdown/StepsDropdown';

interface Props {
    host: string;
    auth: string;
    vehicle: Vehicle;
    stepIx: number;
}

const OrderProgress = ({ vehicle, stepIx, host, auth }: Props): ReactElement => (
    <>
        <DriverContact {...{ vehicle, host, auth }} />
        <StepsDropdown {...{ stepIx }} />
    </>
);

export default OrderProgress;
